const normalizeNullableText = value => (value?.trim() === '' ? null : value);

const normalizeAdditionalAttributes = additionalAttributes => normalizeNullableText(additionalAttributes);

const normalizePhoneNumber = phone => {
    const normalizedPhone = normalizeNullableText(phone);
    if (normalizedPhone === null) return null;
    return normalizedPhone.startsWith('+') ? normalizedPhone : `+${normalizedPhone}`;
};

export { normalizeNullableText, normalizeAdditionalAttributes, normalizePhoneNumber };
